export const environment = {
  production: true,
  path: 'https://www.erudfto.ms.gov.br/rudfto/v1',
  caminhoCustomConfig: 'https://www.erudfto.ms.gov.br/assets/ckeditor_config.js'
};
